import * as types from "./offerwall.constant";

const defaultState = { levelInfo:null , user:null , alternatives:[] , language:"en" , className:"ltr text-left" , gameId:null};

export default function (state = defaultState, action = {}) {
    switch (action.type) {
        case types.OFFER_WALL_ACTION_PERSIST:
            return {
                ...state,
                ...action.payload,
            };
        case types.OFFER_WALL_ACTION_CLEAR:
            return defaultState;
        default:
            return state;
    }
}
